import { render, staticRenderFns } from "./TemplatePreview.yaml?vue&type=template&id=7033f10a&component"
import script from "./TemplatePreview.yaml?vue&type=script&lang=ts&component"
export * from "./TemplatePreview.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports